const getPrevPreferredNumber = (n) => {
    const comparator = isPreferredNumber(n) ? (a, b) => a > b : (a, b) => a >= b;
    const [digit, exponent] = numToDigitAndExponent(n);
    const [nextDigit, nextExponent] = comparator(digit, 5)
        ? [5, exponent]
        : comparator(digit, 2)
            ? [2, exponent]
            : comparator(digit, 1)
                ? [1, exponent]
                : [5, exponent - 1];

    return digitAndExponentToNum(nextDigit, nextExponent);
};

const isPreferredNumber = (n) => {
    const [digit, exponent] = numToDigitAndExponent(n);
    return [1, 2, 5].includes(digit) && digitAndExponentToNum(digit, exponent) === n;
};

const numToDigitAndExponent = (n) => {
    const exponent = Math.floor(Math.log10(n));
    return [Math.floor(n / 10 ** exponent), exponent];
};

const digitAndExponentToNum = (digit, exponent) => digit * 10 ** exponent;

export const findInterval = (field) => {
    if (field) {
        const { minimum, maximum } = field;
        let preferredNum = maximum - minimum;

        const intervals = [...Array(10)]
            .map(() => {
                preferredNum = getPrevPreferredNumber(preferredNum);
                return preferredNum;
            })
            .filter((num) => Number.isInteger(num)) // Only keep integers
            .sort((a, b) => a - b);
        const getBucketCount = (interval) => {
            const getBucketNum = (n) => Math.floor((n + Math.abs(n) * 1e-12) / interval);
            const [bucketNumMin, bucketNumMax] = [minimum, maximum].map(getBucketNum);
            return bucketNumMax - bucketNumMin + 1;
        };

        const suitableInterval = intervals
            .reverse()
            .find((interval) => getBucketCount(interval) >= 10);

        return {
            suitableInterval: suitableInterval || intervals[intervals.length - 1] || 0,
            intervals,
        };
    } else {
        return 0;
    }

};

